import React from 'react';
import getConfig from 'next/config';
import { Grid, Typography, Stack, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './styles';

import EirChannelList from './EirChannelList';

const EirChannelCategory = ({ data }) => {
  const theme = useTheme();
  const { publicRuntimeConfig } = getConfig();

  return (
    <Grid
      container
      item
      spacing={2}
      sx={{ xs: { paddingRight: '0rem' }, md: { paddingRight: '1rem' } }}
    >
      <Grid item xs={12}>
        <Stack direction='row' spacing={1} style={{ alignItems: 'center' }}>
          <Box
            component='img'
            sx={{ width: { md: '20px', xs: '13.33px' }, height: { md: '20px', xs: '13.33px' } }}
            alt={data?.CategoryIcon?.data?.attributes?.alternativeText || 'channel-icon'}
            src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${data?.CategoryIcon?.data?.attributes?.url}`}
          />
          <Typography variant='subtitle1' sx={styles(theme).categoryName}>
            {data?.CategoryName}
          </Typography>
          <Typography variant='body2' sx={styles(theme).categoryCount}>
            ({data?.ContentLogo?.length})
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12} sm={11} md={11} lg={11} sx={styles(theme).channelListMain}>
        <EirChannelList icons={data.ContentLogo} />
      </Grid>
    </Grid>
  );
};

export default EirChannelCategory;
